/**
 * Чи означає помилка запиту, що сесія користувача недійсна.
 *
 * НАВІЩО. Раніше layout-и робили зворотну перевірку: список "транзиентних"
 * помилок (TimeoutError / AbortError / TypeError), а будь-яка інша означала
 * logout. Через це 500/502/504 від бекенду розлогінювали користувача —
 * один деплой або перезапуск Traefik викидав усіх водіїв одночасно.
 *
 * Серверна помилка не свідчить про недійсність сесії. Розлогінювати можна
 * лише при явній відмові автентифікації, тому список тепер прямий:
 * 401 (немає/протух токен) і 403 (доступ заборонено).
 *
 * Статус беремо з кількох місць, бо ky-помилка доходить у різних формах:
 *   - `statusCode` — проставляє RestClientService, коли тіло відповіді
 *     розпарсилось як JSON;
 *   - `response.status` — сирий Response, коли тіло розпарсити не вдалось;
 *   - `status` — вже розпарсене тіло з полем статусу.
 */
export const isAuthFailure = (error: any): boolean => {
    const status =
        (typeof error?.statusCode === 'number' ? error.statusCode : null) ??
        (typeof error?.response?.status === 'number' ? error.response.status : null) ??
        (typeof error?.status === 'number' ? error.status : null)

    return status === 401 || status === 403
}
